import { parseSvgStyle } from '@/icons/utils/svg-styles'
import { ISvgProps } from '@/icons/utils/svg-types'

export const SvgOutlinedSchedule = (props: ISvgProps) => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={parseSvgStyle(props)}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.49 2.79706C6.97 2.79706 2.5 7.27706 2.5 12.7971C2.5 18.3171 6.97 22.7971 12.49 22.7971C18.02 22.7971 22.5 18.3171 22.5 12.7971C22.5 7.27706 18.02 2.79706 12.49 2.79706ZM12.5 20.7971C8.08 20.7971 4.5 17.2171 4.5 12.7971C4.5 8.37706 8.08 4.79706 12.5 4.79706C16.92 4.79706 20.5 8.37706 20.5 12.7971C20.5 17.2171 16.92 20.7971 12.5 20.7971ZM11.5 7.79706H13V13.0471L17.5 15.7171L16.75 16.9471L11.5 13.7971V7.79706Z"
                fill={props.color}
            />
        </svg>
    )
}
